import * as firebase from 'firebase';
import Utils from './Utils';


class FirebaseService{
  constructor(){
    var config = {
      apiKey: "AIzaSyBh_RV2rY62oAMcqnMky98R-srPrBvLbAs",
      authDomain: "baps-370c0.firebaseapp.com",
      databaseURL: "https://baps-370c0.firebaseio.com",
      storageBucket: "bucket.appspot.com"
    };
    firebase.initializeApp(config);
  }
  Login(username,password){
    return firebase.auth().signInWithEmailAndPassword(username,password);
  }
  Logout(){
    return firebase.auth().signOut();
  }
  User(uid){
    return firebase.database().ref('/Users/'+uid).once('value');
  }
  CurrentUser(){
    return firebase.auth().currentUser;
  }
  Users(){
    return firebase.database().ref('Users').orderByChild("FirstName").once('value');
  }
  RegisterUser(email,password){
    return firebase.auth().createUserWithEmailAndPassword(email, password);
  }
  AddUser(user){
    return firebase.database().ref('/Users/'+user.UID).set(user);
  }
  SendResetPasswordEmail(emailAddress){
    return firebase.auth().sendPasswordResetEmail(emailAddress);
  }
  Rooms(){
    return firebase.database().ref('Rooms').orderByChild("Name").once('value');
  }
  Policies(){
    return firebase.database().ref('Policies').orderByChild("ModifiedDate").once('value');
  }
  AddPolicy(policyObj){
    var newPolicyRef = firebase.database().ref('Policies').push();
    policyObj.DocId = newPolicyRef.key;
    policyObj.ModifiedDate = Utils.Dates.ToJsonDate();
    return newPolicyRef.set(policyObj);
  }
  UpdatePolicy(policyObj){
    var id = policyObj.DocId;
    var existingPolicy = firebase.database().ref('Policies/'+id);
    return existingPolicy.update(policyObj);
  }
  GetPolicy(id){
    return firebase.database().ref('Policies/'+id).once('value');
  }
  Issues(){
    return firebase.database().ref('Issues').orderByKey().once('value');
  }
  AddIssue(issueObj){
    var newIssueRef = firebase.database().ref('Issues').push();
    issueObj.IssueId = newIssueRef.key;
    issueObj.CreatedDate = Utils.Dates.ToJsonDate();
    return newIssueRef.set(issueObj);
  }
  
  Announcements(){
    return firebase.database().ref('Announcements').orderByChild("AnnouncementDate").once('value');
  }
  AddAnnouncement(announcementObj){
    var newAnnouncementRef = firebase.database().ref('Announcements').push();
    announcementObj.AnnouncementId = newAnnouncementRef.key;
    return newAnnouncementRef.set(announcementObj);
  }
  GetAnnouncement(id){
    return firebase.database().ref('Announcements/'+id).once('value');
  }
  UpdateAnnouncement(announcementObj){
    var id = announcementObj.AnnouncementId;
    var existingAnnouncement = firebase.database().ref('Announcements/'+id);
    return existingAnnouncement.update(announcementObj);
  }
}

export default new FirebaseService();


// WEBPACK FOOTER //
// ./src/FirebaseService.js